
export class EligSummary {
    constructor(
        public PROGRAM_CD?: string,
        public BENEFIT_AMT?: any,
        public CERT_BEGIN_DT?: any,
        public CERT_END_DT?: any,
        public COUNTY?: string,
        public ABA_MONTHS?: string
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-et-enrollment-elig-summary.model.ts